<template>
  <footer class="footer" id="contact-us">
    <div class="container footer-container">
      <div class="footer-brand">
        <div class="logo">
          <img src="/images/logo.png" :alt="$config.footer.brand" class="logo-img">
        </div>
        <span class="brand-name">{{ $config.footer.brand }}</span>
      </div>
      <div class="footer-links-group">
        <div class="footer-links-column">
          <h3 class="footer-title">{{ $config.footer.contact_us }}</h3>
          <ul class="footer-links">
            <!-- QQ群链接改为直接跳转 -->
            <li><a :href="$config.footer.links.qq_group.url" target="_blank" rel="noopener noreferrer"><img :src="$config.footer.links.qq_group.logo" :alt="$config.footer.links.qq_group.text" class="link-logo">{{ $config.footer.links.qq_group.text }}</a></li>
            <li><a :href="$config.footer.links.xiaohongshu.url" target="_blank" rel="noopener noreferrer"><img :src="$config.footer.links.xiaohongshu.logo" :alt="$config.footer.links.xiaohongshu.text" class="link-logo">{{ $config.footer.links.xiaohongshu.text }}</a></li>
            <li><a :href="$config.footer.links.bilibili.url" target="_blank" rel="noopener noreferrer"><img :src="$config.footer.links.bilibili.logo" :alt="$config.footer.links.bilibili.text" class="link-logo">{{ $config.footer.links.bilibili.text }}</a></li>
            <li><a :href="$config.footer.links.wechat_channel.url" target="_blank" rel="noopener noreferrer"><img :src="$config.footer.links.wechat_channel.logo" :alt="$config.footer.links.wechat_channel.text" class="link-logo">{{ $config.footer.links.wechat_channel.text }}</a></li>
          </ul>
        </div>
        <div class="footer-links-column">
          <h3 class="footer-title">{{ $config.footer.quick_links }}</h3>
          <ul class="footer-links">
            <li><router-link :to="$config.footer.quick_links_urls.download">{{ $config.footer.quick_links_items.download }}</router-link></li>
            <li><a :href="$config.footer.quick_links_urls.install_guide" target="_blank" rel="noopener noreferrer">{{ $config.footer.quick_links_items.install_guide }}</a></li>
            <li><a :href="$config.footer.quick_links_urls.usage_guide" target="_blank" rel="noopener noreferrer">{{ $config.footer.quick_links_items.usage_guide }}</a></li>
            <li><a :href="$config.footer.quick_links_urls.faq" target="_blank" rel="noopener noreferrer">{{ $config.footer.quick_links_items.faq }}</a></li>
            <li><a :href="$config.footer.quick_links_urls.update" target="_blank" rel="noopener noreferrer">{{ $config.footer.quick_links_items.update }}</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer-legal">
      <p class="legal-text">
        <span>copyright @galiyuejuan.com</span>
        <span class="separator">|</span>
        <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">湘ICP备2021012256号-4</a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background-color: rgba(8, 34, 38, 1);
  color: #E2E8F0;
  padding: 50px 0;
}

.footer-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 120px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-brand {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.logo {
  margin-right: 16px;
}

.logo-img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.brand-name {
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
}

.footer-links-group {
  display: flex;
  gap: 100px;
}

.footer-links-column {
  text-align: left;
}

.footer-title {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 20px;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: #A0AEC0;
  text-decoration: none;
  font-size: 14px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: #fff;
}

.link-logo {
  width: 16px;
  height: 16px;
  margin-right: 10px;
  object-fit: contain;
  flex-shrink: 0;
}

.link-icon {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #A0AEC0;
  border-radius: 50%;
  margin-right: 10px;
}

.footer-legal {
  margin-top: 24px;
  text-align: center;
  color: #A0AEC0;
}

.legal-text {
  font-size: 14px;
  line-height: 1.6;
}

.footer-legal a {
  color: #A0AEC0;
  text-decoration: none;
}

.footer-legal a:hover {
  color: #fff;
}

.separator {
  margin: 0 8px;
}

/* 768px以下移动端适配 */
@media (max-width: 768px) {
  .footer {
    padding: 40px 0;
  }
  
  .footer-container {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 40px;
    padding: 0 20px;
  }
  
  .footer-brand {
    justify-content: center;
    margin-bottom: 0;
  }
  
  .footer-links-group {
    flex-direction: column;
    gap: 32px;
    width: 100%;
    align-items: center;
  }
  
  .footer-links-column {
    text-align: center;
    width: 100%;
    max-width: 300px;
  }
  
  .footer-title {
    margin-bottom: 16px;
    font-size: 18px;
  }
  
  .footer-links {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .footer-links li {
    margin-bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: left;
  }
  
  .footer-links a {
    justify-content: left;
    padding: 8px 16px;
    border-radius: 6px;
    transition: all 0.3s ease;
    width: fit-content;
  }
  
  .footer-links a:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
}
</style>